import {Row, Col, Form, Input, Space, Button, DatePicker} from 'antd';
import classes from '../Pages.module.css';
import { MinusCircleOutlined, PlusCircleOutlined} from '@ant-design/icons';

const MembershipEdit = (props) => {

    const handleValueChanges = (changedValues, allValues) => {
        props.setData(data => {
            return({
                ...data,
                membership: allValues.membership
            })
        })
    }

    return(
        <Form layout="vertical" name="filter_form" onValuesChange = {handleValueChanges} autoComplete="off">
            <Form.List name="membership" initialValue = {props.data}>
                {(fields, { add, remove }) => { 
                    
                    return(
                    <>
                        {fields.map(({ key, name, fieldKey, ...restField}) => (
                        <Space key={key} className = {classes['Space']} align="center">
                            <Row gutter = {16}>
                                <p></p>
                                <Col lg = {6} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'MEMBERSHIP']}
                                        fieldKey={[fieldKey, 'MEMBERSHIP']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>Membership</div>}
                                        // rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                        <Input
                                            style={{ width: "100%" , float: "left", backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}} 
                                            bordered = {true}
                                            placeholder="Enter Name"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col lg = {6} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'MEM_LEVEL']}
                                        fieldKey={[fieldKey, 'MEM_LEVEL']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>Member Level</div>}
                                        // rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                        <Input
                                            style={{ width: "100%" , float: "left", backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}} 
                                            bordered = {true}
                                            placeholder="Enter Data"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col lg = {6} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'SINCE_DATE']}
                                        fieldKey={[fieldKey, 'SINCE_DATE']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>Since Date</div>}
                                        // rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                        <DatePicker
                                            format="DD-MM-YYYY"
                                            style={{ textAlign: "left", width: "100%" , backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}}
                                            bordered = {true}
                                            placeholder="Enter Date" />
                                    </Form.Item>
                                </Col>
                                <Col lg = {6} md = {24}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'EXPIRY_DATE']}
                                        fieldKey={[fieldKey, 'EXPIRY_DATE']}
                                        label = {<div style = {{padding: "0rem 0.5rem", fontSize: "0.6rem", fontWeight: "bold"}} className={classes['Label']}>Expiry Date</div>}
                                        // rules={[{ required: true, message: 'Missing Name' }]}
                                    >
                                       <DatePicker
                                            format="DD-MM-YYYY"
                                            style={{ textAlign: "left", width: "100%" , backgroundColor : "white", color: "#1777C4", fontWeight: "bold", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}}
                                            bordered = {true}
                                            placeholder="Enter Date" />
                                    </Form.Item>
                                </Col>
                                <Col lg = {21} md = {0}>
                                    
                                </Col>
                                <Col lg = {1} md = {24}>
                                    <MinusCircleOutlined className = {classes['Remove']} onClick={() => { remove(name) }} />
                                </Col>
                                <Col lg = {1} md = {24}>
                                    <PlusCircleOutlined className = {classes['Add']} onClick={() => {add()}} />
                                </Col>
                                <Col lg = {1} md = {24}>
                                    
                                </Col>
                                <Col lg = {24} md = {24}>
                                    <hr></hr>
                                </Col>
                            </Row>                                                     
                        </Space>
                        ))}
                        <Form.Item>
                            <Button type="dashed" className = {classes['DashedButton']}onClick={() => {add()}}>
                                Add Membership
                            </Button>
                        </Form.Item>
                    </>
                )}}
            </Form.List>
        </Form>
    )
}

export default (MembershipEdit)